<template>
  <el-dialog
    title="商品维护"
    :visible="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="30%"
    key="1"
    :modal="false"
    :before-close="handleDialogClose">
    <div>
      <el-form v-if="visible" :model="formData" ref="mallConsumablesDialogForm" label-width="150px" class="dialog-form-wrap">
        <el-form-item label="原库存数：" prop="inventoryorg" v-if="formData.id">
          <span>{{formData.inventoryorg}}</span>
        </el-form-item>
        <el-form-item v-if="!formData.id" label="商品：" prop="goodsId"
          :rules="[
            { required: true, message: '商品不能为空'}
          ]"
        >
          <el-select v-model="formData.goodsId" placeholder="请选择商品" filterable>
            <el-option v-for="(dataItem, dataIndex) in goodsList" :key="dataIndex" :label="dataItem.goodsNo + ' ' + dataItem.title"
                       :value="dataItem.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="库存数：" prop="inventory"
          :rules="[
            { required: true, message: '库存数不能为空'},
            { pattern: /^[+]{0,1}(\d+)$/, message: '请输入不小于0的整数', trigger: 'blur' }
          ]"
        >
          <el-input v-model.trim="formData.inventory" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="备注：" prop="remark">
          <el-input type="textarea" v-model.trim="formData.remark" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="handleDialogClose">取 消</el-button>
      <el-button size="small" type="primary" @click="submitForm">保 存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'SiteGoodsCedit',
  props: ['visible', 'formData'],
  isAutoComponent: true,
  data() {
    return {
      goodsList: []
    }
  },
  methods: {
    handleDialogClose() {
      this.$emit('update:visible', false)
    },
    submitForm() {
      const that = this
      this.$refs.mallConsumablesDialogForm.validate((valid) => {
        if (valid) {
          if (that.formData.id) { // 编辑
            that.$api.siteManage.goods.siteGoodsEdit(that.formData).then(res => {
              that.toSuccess()
            })
          } else {
            that.formData.siteId = this.detailFormData.id
            that.$api.siteManage.goods.siteGoodsAdd(that.formData).then(res => {
              that.toSuccess()
            })
          }
        } else {
          return false
        }
      })
    },
    toSuccess() {
      this.$message({ message: '保存成功', type: 'success' })
      this.handleDialogClose()
      this.$emit('refreshData')
    },
    queryGoodsList() {
      this.$api.siteManage.goods.siteGoodsListNoAdd({
        id: this.detailFormData.id
      }).then(res => {
        this.goodsList = res.data
      })
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.queryGoodsList()
      }
    }
  },
  computed: {
    ...mapState({
      detailFormData: state => state.siteManage.siteDetailData
    })
  }
}
</script>

<style>
</style>
